import {Bar, mixins} from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  data () {
    return {
      options: {
        scales: {
          yAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true,
              precision: 0,
            },
            gridLines: {
              display: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Number of Learners'
            },
          }],
          xAxes: [ {
            stacked: true,
            maxBarThickness: 90,
            gridLines: {
              display: false
            },
            scaleLabel: {
              display: true,
              labelString: 'Interactions'
            },
            // ticks: {
            //   fontFamily: 'Material Icons',
            //   fontSize: 18
            // }
          }]
        },
        legend: {
          display: true
        },
        title: {
          display: true,
          text: 'Bulb Interaction Summary',
          position: 'top'
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            // align: 'end',
            anchor: 'center',
            font: {
              // family: 'Material Icons',
              size: 5,
            },
            formatter: function(value, context) {
              return context.chart.data.labels[context.dataIndex];
            },
            display: false
          },
        }
      }
    };
  },
  mounted () {
    this.renderChart(this.chartData, this.options);
  }
};